import React, { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import './Contact.css';
import BackToTop from './BackToTop';
import ButtonZap from '../components/ButtonZap';
import Title from '../styled-components/Title';
import Title2 from '../styled-components/Title2';
import {
  administrativoEmail,
  administrativoZap,
  atendimentoEmail,
  atendimentoZap,
  comercialEmail,
  comercialZap,
  financeiroEmail,
  financeiroZap,
  geralTel,
  cedocLocationArm,
  cedocLocationAdm
} from '../imports/Links';
import background from '../imgs/bg-cedoc.jpg';

function Contact({ bgImg = `url(${background})` }) {
  const [inProp, setInProp] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setInProp(true);
    }, 100);
  }, []);

  return (
    <div className="Contact">
      <CSSTransition in={inProp} timeout={500} classNames="fade" unmountOnExit>
        <main>
          <Title>Suporte e Contato</Title>

          <div className="contact-grid">
            <div className="contact-card">
              <h3>📍 Localização Administrativo</h3>
              <p><a href={cedocLocationAdm} target="_blank" rel="noreferrer">Avenida Portugal, 399 Jardim Atlântico</a></p>
              <p><a href={cedocLocationAdm} target="_blank" rel="noreferrer">Belo Horizonte - MG</a></p>
              <p><a href={cedocLocationAdm} target="_blank" rel="noreferrer">CEP 31550-000</a></p>
            </div>

            <div className="contact-card">
              <h3>🏢 Localização Armazenamento</h3>
              <p><a href={cedocLocationArm} target="_blank" rel="noreferrer">Rua Alcobaça, 831 São Francisco</a></p>
              <p><a href={cedocLocationArm} target="_blank" rel="noreferrer">Belo Horizonte - MG</a></p>
              <p><a href={cedocLocationArm} target="_blank" rel="noreferrer">CEP 31255-210</a></p>
            </div>

            <div className="contact-card">
              <h3>📧 Atendimento</h3>
              <p><a href={atendimentoEmail} target="_blank" rel="noreferrer">atendimento@cedoc.net.br</a></p>
              <p><a href={atendimentoZap} target="_blank" rel="noreferrer">(31) 97171-6237</a></p>
            </div>

            <div className="contact-card">
              <h3>📞 Geral</h3>
              <p><a href={geralTel} target="_blank" rel="noreferrer">(31) 3656-2040</a></p>
            </div>

            <div className="contact-card">
              <h3>💼 Administrativo</h3>
              <p><a href={administrativoEmail} target="_blank" rel="noreferrer">administrativo@cedoc.net.br</a></p>
              <p><a href={administrativoZap} target="_blank" rel="noreferrer">(31) 99570-4986</a></p>
            </div>

            <div className="contact-card">
              <h3>💰 Financeiro</h3>
              <p><a href={financeiroEmail} target="_blank" rel="noreferrer">financeiro@cedoc.net.br</a></p>
              <p><a href={financeiroZap} target="_blank" rel="noreferrer">(31) 97208-9557</a></p>
            </div>

            <div className="contact-card">
              <h3>🤝 Comercial</h3>
              <p><a href={comercialEmail} target="_blank" rel="noreferrer">comercial@cedoc.net.br</a></p>
              <p><a href={comercialZap} target="_blank" rel="noreferrer">(31) 97171-4838</a></p>
            </div>
          </div>
        </main>
      </CSSTransition>

      <BackToTop />
      <ButtonZap />
    </div>
  );
}

export default Contact;
